import {ProjectSystemType} from "../../../../../../core/model2/project/types"

const customerHelpdesk = {
    "id": "yglqBO",
    "name": "Customer Helpdesk",
    "img": "/app/static/templates/it/helpdesk.jpg",
    "description": "Support request management and status view at-a-glance.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'IT',
    demoFolderColor: 20
};

const testing = {
    "id": "hHva6d",
    "name": "Testing / QA",
    "img": "/app/static/templates/it/testing.jpg",
    "description": "Manage QA testing process and test cases with this template.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'IT',
    demoFolderColor: 20
};

const serviceDesk = {
    "id": "aaaIhV",
    "name": "IT Service Desk",
    "img": "/app/static/templates/it/service-desk.jpg",
    "description": "Preconfigured board template for IT request tracking.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'IT',
    demoFolderColor: 20
};

const userStoryMapping = {
    "id": "pKvr4v",
    "name": "User Story Mapping",
    "img": "/app/static/templates/product/user-story.jpg",
    "description": "Record and assign user stories to sprints with this template.",
    systemType: ProjectSystemType.BACKLOG,
    copyToLocalTemplate: false,
    setupDemoProject: 'IT',
    demoFolderColor: 20
};

const productRoadmap = {
    "id": "c03n1i",
    "name": "Product Roadmap",
    "img": "/app/static/templates/product/roadmap.jpg",
    "description": "Quarterly product planning template with timeline.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'IT',
    demoFolderColor: 20
};

const feedback = {
    "id": "6sdk2u",
    "name": "User Feedback",
    "img": "/app/static/templates/product/feedback.jpg",
    "description": "Track two-way communication with users and feedback response.",
    systemType: ProjectSystemType.BACKLOG,
    copyToLocalTemplate: false,
    setupDemoProject: 'IT',
    demoFolderColor: 20
};

const issueTracker = {
    "id": "UaaYVb",
    "name": "Issue Tracker",
    "img": "/app/static/templates/it/issue-tracking.jpg",
    "description": "Workflows to track and resolve product issues.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'IT',
    demoFolderColor: 20
};

const contractorManagement = {
    "id": "EMs04U",
    "name": "Contractor Management",
    "img": "/app/static/templates/hr/contractors.jpg",
    "description": "Template to record key contractor information and contract details.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'IT',
    demoFolderColor: 20
};


export default {
    id: 'it',
    name: "IT & Engineering",
    items: [

        customerHelpdesk,
        testing,
        serviceDesk,

        userStoryMapping,
        productRoadmap,
        feedback,
        issueTracker,
        // agile,

        contractorManagement,
    ]
}